import React from 'react'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'

interface Props {
  startLocation?: string | null
  size?: 'small' | 'medium' | 'large'
}

function BookmarkLocationSingle({ startLocation, size = 'large' }: Props) {
  return (
    <CaptionTextBlock variant={size} lineClamp={2}>
      {startLocation}
    </CaptionTextBlock>
  )
}

export default BookmarkLocationSingle
